import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { DrivePostRegistrationForm } = await import('./index');
    return {
        Component: DrivePostRegistrationForm,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
